export default __webpack_public_path__ + "static/media/Type 5 Cover.1e57b046.jpg";